export const blankArr = [];
export const blankObj = {};

/**
 * A list.map for objects
 */
export const map = (obj, fn) =>
  Object.keys(obj)
    .reduce((result, key) => {
      result[key] = fn(obj[key], key);
      return result;
    }, {});

/**
 * A list.filter for objects
 */
export const filter = (obj, fn) =>
  Object.keys(obj)
    .reduce((result, key) => {
      if (fn(obj, key)) result[key] = obj[key];
      return result;
    }, {});


/**
 * A missing rest spread helper for last arguments
 * Desired spread:
 * (...args, lastArg) => { ... }
 * (...args, lastArg1, lastARg2) => { ... }
 *
 * How to:
 * spreadLast((args, lastArg) => { ... })
 * spreadLast((args, lastArg1, lastArg2) => { ... }, 2)
 */
export const spreadLast = (wrappedFn, count = 1) =>
  (...args) => {
    const restArgs = args.slice();
    const lastArgs = restArgs.splice(-count, count);
    return wrappedFn(restArgs, ...lastArgs);
  };

export const flatten = arrayOfArrays => [].concat(...arrayOfArrays);
export const distinct = arrayWithDuplicates => Array.from(new Set(arrayWithDuplicates));
export const isPlainObject = obj => Object.prototype.toString.call(obj) === '[object Object]';
export const isFunction = (func) => typeof func === 'function';

/**
 * A useful function to print result of another method call,
 * without interrupting the execution
 * do not delete even if unused
 */
export const logFunctionResult = (title, fn) => (...args) => {
  const value = fn(...args);
  console.log(title, { result: value, args });
  return value;
};

export const convertListToObjectBy =
  <T extends Record<string, any>>(field: string) =>
    (list: T[]): Record<string, T> =>
      list.reduce((result: Record<string, T>, item: T) => {
        result[item[field]] = item;
        return result;
      }, {});

export const getSlicedString = (str, index) =>
  (str.length > index ? `${str.slice(0, index)}...` : str);
